import favoritesAPI from './favoritesAPI'
import oportunitiesAPI from './oportunitiesAPI'
import leadAPI from './leadAPI'
import adobeAPI from './adobeAPI'

export { favoritesAPI, oportunitiesAPI, leadAPI, adobeAPI }
